import React, { useContext } from 'react'
import { ConfirmationContext } from '../../../../../Confirmation'
import { useDownloadControlsReport } from '../../../../../components/async/model/control'

export function useDownloadControlsReportModal(): () => void {
  const { setConfirmationState } = useContext(ConfirmationContext)
  const onConfirmCB = useDownloadControlsReport()
  return () => {
    setConfirmationState({
      isShown: true,
      size: 'lg',
      title: 'Export Control Detail CSV',
      body: (
        <p>
          Trustero will gather the data to create a csv file of working
          controls.
        </p>
      ),
      confirmText: 'Export Control CSV',
      onConfirmCB,
    })
  }
}
